/**
 * HealthDashboardPage.js
 * Admin page for viewing customer health data (fitness & glucose)
 */
import React from 'react';
import AdminHealthDashboard from '@/components/admin/AdminHealthDashboard';

const HealthDashboardPage = () => {
  return <AdminHealthDashboard />;
};

export default HealthDashboardPage;
